import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FlightsService {

  constructor(
    private _http: HttpClient
  ) { }

  getAllFlightData(payload:any): Observable<any> {
    return this._http.post<any>(`${environment.travelintegration}/SearchFlights`, payload);
  }
}
